import type { CSSProperties } from "react";

/**
 * Colour a "days overdue" table cell by severity. Shared across every
 * task-execution table so the thresholds/colours stay consistent.
 */
export const getDaysOverdueCellStyle = (
  days: number | null | undefined
): CSSProperties => {
  if (days == null) return {};
  if (days === 0) return { backgroundColor: "#bbf7d0" };
  if (days >= 1 && days <= 7) return { backgroundColor: "#fef08a" };
  return { backgroundColor: "#fecaca" };
};
